import { initializeFirebase } from '@/firebase/firebaseInit'
import loggerLocal, { safeToStringLocal } from '@/utils/loggerLocal'


import { useStoreError } from '@/stores/storeError'
import { useStoreUser } from '@/stores/storeUser'

import { type ActionCodeSettings, type User, getAuth, sendPasswordResetEmail } from '@firebase/auth'

import { useStoreAuth } from '@/stores/storeAuth'

import { getProviderUser } from './auth'
import {
    be_getLoginUserData,
    be_getUser,
    be_listCompanyUser,
    be_mutateUser,
    be_mutateUserCompany,
} from './backEndCaller'

import { DBMutationType, DBRetCode } from '@functions/models/DBEnum'


import { i18nGlobal } from '@/i18n'
import { useStoreCodeTables } from '@/stores/storeCodeTables'
import { showErrorMessage, showSuccessUpdateMessage } from '@/utils/showMessage'
import { type IntCompanyData } from '@functions/models/interfaces/intCompany'
import { type IntLinkedCompanyData } from '@functions/models/interfaces/intLinkedCompany'
import { type IntUserData } from '@functions/models/interfaces/intUser'
import { type IntUserCompanyData } from '@functions/models/interfaces/intUserCompany'
import { type IOGetUserRequest, type IOGetUserResponse } from '@functions/models/ioInterfaces/ioGetUser'
import type { IOListCompanyRequest } from '@functions/models/ioInterfaces/ioListCompany'
import { type IOListCompanyUserRequest, type IOListCompanyUserResponse } from '@functions/models/ioInterfaces/ioListCompanyUser'
import type { IOMutateUserRequest, IOMutateUserResponse } from '@functions/models/ioInterfaces/ioMutateUser'
import type { IOMutateUserCompanyRequest } from '@functions/models/ioInterfaces/ioMutateUserCompany'
import { type IOSignInResponse } from '@functions/models/ioInterfaces/ioSignIn'
import { callListCompany } from './company'
import { uploadProfileImage } from './storage'



const firebase = await initializeFirebase()
//const companyCollectionRef = firebase.companyCollectionRef
const db = firebase.db




//NEW
export async function getUserData ( idProvider?: string ): Promise<IOSignInResponse | undefined> {
    const functionName = 'getUserData'
    loggerLocal.info( functionName, idProvider )
    const storeUser = useStoreUser()
    const storeCodeTables = useStoreCodeTables()

    const storeAuth = useStoreAuth()
    try
    {
        const providerToUse = idProvider ?? ( ( ( await getProviderUser() ) as User ).uid as string )
        let userData: IntUserData = {}

        storeUser.fetching = true
        const resUser = await be_getLoginUserData( { idProvider: providerToUse } )
        loggerLocal.info( functionName + ' resUser', resUser )
        if ( resUser && resUser.isRegistered )
        {
            storeUser.setStoreUserData( resUser.user )
            storeUser.setStoreCompanyData( resUser.company )
            storeUser.setStoreUserCompanyData( resUser.userCompany )
            storeUser.setStoreLinkedCompanies( resUser.linkedCompanies )
            storeAuth.setStoreAuthorization( resUser?.auth ?? [] )
            storeUser.setStoreIsCompanyManager( resUser.isCompanyManager ?? false )
            storeUser.setStoreIsCompanySeller( resUser.isCompanySeller ?? false )
            storeUser.setStoreIsCompanyClient( resUser.isCompanyClient ?? false )
            storeUser.setStoreIsSuperAdmin( resUser.isSuperAdmin ?? false )
            storeCodeTables.setCodeTables( resUser.codeTables )
            storeCodeTables.setCodeTablesName( resUser.codeTablesName )
            loggerLocal.info( functionName, ' user and company data stored in storeUser' )
            //if (resUser.userCompany.role === DBRole.ADMIN) {
            //}
        }
        storeUser.fetching = false
        storeUser.loaded = true
        return resUser
    } catch ( e )
    {
        storeUser.fetching = false
        loggerLocal.error( 'getUserData error', e )
        const storeError = useStoreError()
        storeError.setError( i18nGlobal.t( 'error.getDataError' ) + ' ' + functionName, e )
        return undefined
    }
}



export async function getUserAndCompanyData ( idUser: string ): Promise<IOGetUserResponse | undefined> {
    const functionName = 'getUserAndCompanyData'
    const storeUser = useStoreUser()
    const input: IOGetUserRequest = {
        idUser,
        idCompany: storeUser?.companyData?.id ?? '',
    }
    const res = await be_getUser( input )
    if ( res.result === DBRetCode.SUCCESS )
    {
        return res
    } else
    {
        const storeError = useStoreError()
        storeError.setError( 'Errore nel recupero dei dati ' + functionName, res )
        return undefined
    }
}


export async function getCompany ( idCompany: string ): Promise<IntCompanyData | undefined> {

    /*const inputCall: IOListCompanyUserRequest = {
        idCompany,
        //urlRedirect: window.location.origin,
    }
    const res = await be_listCompanyUser( inputCall )
    if ( res.result === DBRetCode.SUCCESS )
    {
        if ( res.usersWithRole.length > 0 )
        {
            return res.usersWithRole[ 0 ]?.company ?? null
        }
    }*/
    const inputCall: IOListCompanyRequest = {
        idCompany,
    }
    const res = await callListCompany( inputCall )
    if ( res.result === DBRetCode.SUCCESS )
    {
        if ( res.company.length > 0 )
        {
            return res.company[ 0 ] ?? undefined
        }
    }

    return undefined
}


export async function callListCompanyUser ( input: IOListCompanyUserRequest ): Promise<IOListCompanyUserResponse> {
    const functionName = callListCompanyUser.name
    loggerLocal.info( functionName, input )
    const storeUser = useStoreUser()
    const inputCall: IOListCompanyUserRequest = {
        idCompany: input?.idCompany ?? storeUser.companyData.id,
        idUser: input.idUser,
        role: input.role,
        idUserCompany: input.idUserCompany,
        status: input.status,
        //urlRedirect: window.location.origin,
        pagination: input.pagination,
    }
    const res = await be_listCompanyUser( inputCall )
    if ( res.result === DBRetCode.ERROR )
    {
        const storeError = useStoreError()
        storeError.setError( 'Errore nel recupero dei dati callListCompanyUser', res )
    }
    return res
}



export async function getUserCompanyDBData (
    idUserCompany: string,
    idUser: string,
): Promise<IntUserCompanyData | null> {
    //if (isDBNew) {
    const storeUser = useStoreUser()
    const input: IOListCompanyUserRequest = {
        idCompany: storeUser?.companyData?.id ?? '',
        idUserCompany: idUserCompany,
        idUser: idUser,
    }
    const res = await callListCompanyUser( input )
    if ( res.result === DBRetCode.SUCCESS )
    {
        if ( res.usersWithRole.length > 0 )
        {
            return res.usersWithRole[ 0 ]?.userCompany[ 0 ] ?? null
        }
    }
    /*} else {
        return await getUserCompanyDBDataOldDB(idUserCompany, idUser)
    }*/
    return {}
}


/*export interface IUserAndCompany {
    userData: IntUserData
    companyData: IntCompanyData
    userCompanyData: IntUserCompanyData
}*/


export async function getAndStore_UserAndCompany ( idProvider?: string, idCompany?: string ): Promise<IOSignInResponse> {
    //if (isDBNew) {
    const res = await getUserData( idProvider )
    if ( res )
    {
        return res
    } else
    {
        const output: IOSignInResponse = {
            user: {},
            company: {},
            userCompany: {},
            linkedCompanies: [],
            auth: [],
            codeTables: [],
            codeTablesName: [],
            isRegistered: false,
            result: DBRetCode.ERROR,
            isCompanyManager: false,
            isCompanySeller: false,
            isCompanyClient: false,
            isSuperAdmin: false,
        }
        return output
    }

}

interface IGetLinkedCompanyResponse {
    linkedCompany: IntLinkedCompanyData[]
    recordCount: number
}



export interface IGetUserCompanyListResponse {
    usersCompany: Array<IntUserCompanyData>
    users: Array<IntUserData>
    recordCount: number
    result: DBRetCode
}

//migrated
export async function getUserCompanyList ( input?: IOListCompanyUserRequest ): Promise<IGetUserCompanyListResponse> {
    const functionName = getUserCompanyList.name
    const output: IGetUserCompanyListResponse = {
        usersCompany: [],
        users: [],
        recordCount: 0,
        result: DBRetCode.WARNING,
    }

    try
    {
        const storeUser = useStoreUser()
        //  let isAdmin = storeUser.userCompanyData.role === DBRole.ADMIN



        const inputList: IOListCompanyUserRequest = {
            ...input,
            //urlRedirect: window.location.origin,
            idCompany: storeUser?.companyData?.id ?? '',
        }
        const res = await be_listCompanyUser( inputList )
        for ( let i = 0; i < res.usersWithRole.length; i++ )
        {
            const userWithRole = res.usersWithRole[ i ]
            const userCompanyData = userWithRole ? userWithRole.userCompany[ 0 ] : undefined
            if ( userCompanyData )
            {
                output.usersCompany.push( userCompanyData )
            }
            if ( userWithRole )
            {
                output.users.push( userWithRole.user )
            }
        }
        output.recordCount = output.usersCompany.length



    } catch ( e )
    {
        const errString = i18nGlobal.t( 'error.getDataError' ) + ' ' + functionName + safeToStringLocal( e )
        loggerLocal.error( errString, e )
        showErrorMessage( undefined, errString )
    }
    return output

}




export async function mutateUserCompany (
    mutationType: DBMutationType,
    userCompanyData: IntUserCompanyData,

): Promise<IOMutateUserResponse> {
    const storeUser = useStoreUser()
    let output: IOMutateUserResponse = {
        user: {},
        userCompany: {},
        company: {},
        result: DBRetCode.WARNING,
        userAlreadyExist: false,
        userRequestorId: storeUser?.userData?.id ?? '',
    }
    const input: IOMutateUserRequest = {
        mutationType,
        userCompany: userCompanyData,
        user: {
            id: userCompanyData?.idUser as string,
            displayName: userCompanyData.userDisplayName as string,
            email: userCompanyData.email as string,
            internationalPrefix: '+39',
            mobile: userCompanyData.mobile as string,
        },
        userRequestorId: storeUser.userData.id,
    }
    try
    {
        const res = await callMutateUser( input, false )
        if ( res.result !== DBRetCode.ERROR )
        {
            const auth = getAuth()
            const actionCodeSettings: ActionCodeSettings = {
                url: window.location.origin,
            }
            output.user = res.user
            output.userCompany = res.userCompany
            output.company = res.company


            if (
                mutationType == DBMutationType.INSERT &&
                res?.user?.email &&
                res.user.email !== '' &&
                !res.userAlreadyExist
            )
            {
                loggerLocal.info( '***** Password reset email starting ***' )
                await sendPasswordResetEmail( auth, res.user.email as string, actionCodeSettings )
                    .then( () => {
                        loggerLocal.info( '***** Password reset email sent! ***' )
                    } )
                    .catch( error => {
                        const errorCode = error.code
                        const errorMessage = error.message
                        const storeError = useStoreError()
                        storeError.setError( "Errore nell'invio della mail all'utente", error )
                        loggerLocal.error( 'Errore nell invio della mail all utente', error )
                        return null
                        // ..
                    } )
            } else
            {
                loggerLocal.info( ' Password reset email NOT SENT ', res?.user?.email ?? 'NOEMAIL', res, mutationType )
            }
            showSuccessUpdateMessage()
        } else
        {
            showErrorMessage()
        }
    } catch ( e )
    {
        showErrorMessage( undefined, e )
    }
    return output
}

export async function mutateOnlyUserData ( user: IntUserData ) {

    const storeUser = useStoreUser()
    const inputMutateUser: IOMutateUserRequest = {
        mutationType: DBMutationType.UPDATE,
        userRequestorId: storeUser.userData.id,
        user,
        userCompany: {},
    }
    const res = await callMutateUser( inputMutateUser, false )
    return res.user

}

export async function callMutateUser ( input: IOMutateUserRequest, storeIt: boolean ): Promise<IOMutateUserResponse> {
    const inputMutation: IOMutateUserRequest = input
    const storeUser = useStoreUser()
    inputMutation.userRequestorId = storeUser.userData.id
    //inputMutation.userCompany.idCompany = storeUser.companyData.id
    const res = await be_mutateUser( inputMutation )
    if ( res.result === DBRetCode.ERROR )
    {
        const storeError = useStoreError()
        storeError.setError( 'Errore nel salvataggio dei dati mutateUser', res )
        return res
    } else
    {
        if ( storeIt )
        {
            storeUser.userData = res.user
            //storeUser.userCompanyData = res.userCompany
        }
        return res
    }
}


export async function mutateUserData ( user: IntUserData ) {

    const storeUser = useStoreUser()
    const inputMutateUser: IOMutateUserRequest = {
        mutationType: DBMutationType.UPDATE,
        userRequestorId: storeUser.userData.id,
        user,
        userCompany: {},
    }
    const res = await callMutateUser( inputMutateUser, true )
    return res.user

}





export async function callMutateUserCompany ( input: IOMutateUserCompanyRequest ): Promise<boolean> {
    try
    {
        const inputMutate: IOMutateUserCompanyRequest = {
            ...input,
        }
        const resUpd = await be_mutateUserCompany( inputMutate )
        loggerLocal.error( 'callMutateUserCompany resUpd', resUpd )
        if ( resUpd && resUpd.result === DBRetCode.SUCCESS )
        {
            const res = await getUserData()
            if ( res )
            {
                return true
            }
        }
        return false
    } catch ( e )
    {
        loggerLocal.error( 'callMutateUserCompany error', e )
        const storeError = useStoreError()
        storeError.setError( i18nGlobal.t( 'error.getDataError' ) + ' callMutateUserCompany', e )
        return false
    }
}

export interface IMutateUserDataNewBERequest {
    mutationType: DBMutationType
    userData: IntUserData
    profileImage: File | undefined | null
    userCompanyData: IntUserCompanyData | undefined
}

export async function mutateUserDataNewBE ( input: IMutateUserDataNewBERequest ): Promise<IntUserData | undefined> {
    const { mutationType, userData, profileImage, userCompanyData } = input
    loggerLocal.info( 'mutateUserData', userData )
    try
    {
        const storeUser = useStoreUser()
        const userRequestorId = storeUser.userData?.id
        if (
            ( userData.id === undefined || userData.id === null || userData.id === '' ) &&
            mutationType !== DBMutationType.INSERT
        )
        {
            userData.id = userRequestorId
        }
        loggerLocal.info( 'mutateUserData profileImage ', profileImage )
        if ( !!profileImage && profileImage !== null )
        {
            //loggerLocal.info('mutateUserData profileImage entered ', profileImage)
            const resUpload = await uploadProfileImage( profileImage, userData.id as string )
            if ( resUpload )
            {
                userData.imageUrl = resUpload
            } else
            {
                return null as unknown as IntUserData
            }
        }
        const mutateUserCompanyData: IntUserCompanyData = {
            ...userCompanyData,
            idUser: userData.id,
            idCompany: userCompanyData?.idCompany ?? storeUser.companyData?.id,
        }
        //loggerLocal.info('mutateUserData mutateCompanyRoleData ', mutateCompanyRoleData)
        const inputMutateUser: IOMutateUserRequest = {
            user: userData,
            userCompany: mutateUserCompanyData,
            mutationType: mutationType,
            userRequestorId,
        }
        const resUser = await be_mutateUser( inputMutateUser )
        //loggerLocal.info('mutateUserData resUser', resUser)
        if ( resUser && resUser.result === DBRetCode.SUCCESS )
        {
            if ( userRequestorId === userData.id )
            {
                storeUser.setStoreUserData( resUser.user )
            }
            const storeError = useStoreError()
            storeError.setSuccess( i18nGlobal.t( 'error.updSuccess' ) as string )
        } else
        {
            const storeError = useStoreError()
            storeError.setError( i18nGlobal.t( 'error.updError' ) + ' mutateUserData', resUser )
        }
        return resUser.user
    } catch ( e )
    {
        loggerLocal.error( 'mutateUserData error', e )
        const storeError = useStoreError()
        storeError.setError( i18nGlobal.t( 'error.updError' ) + ' mutateUserData', e )
        return undefined
    }
}

